import { Services } from '../../types/services';

interface Group {
  id: string;
  name?: string;
  practices?: string[];
  [key: string]: unknown;
}

interface State {
  groups: Group[];
}

const initialState: State = {
  groups: [],
};

interface Action {
  type: string;
  payload?: unknown;
}

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = (services: Services) => {
  const axiosService = services.axios.Axios();

  const getAllGroups = () => async () => axiosService.get<Group[]>('practices/groups');

  return {
    getAllGroups,
  };
};
